import styled from "../Themes";

export const MapContainer = styled(`div`)`
  clear: both;
  height: 400px;
  margin: 12px 0;
  border: 1px solid ${({ theme }) => theme.color.font_bold[2]};
  border-radius: 3px;
`;
